/* Tuiles packshot sans bandes (03/10/2026). Une photo non carrée posée en `contain` dans une tuile carrée laisse deux
   bandes ; sur le fond blanc du site, la tuile (dégradé très clair hérité du thème sombre) et le fond propre de la photo
   (blanc pur, gris clair, beige…) ne coïncident jamais : rectangle visible autour de la chaussure, surtout en grand
   (3 colonnes, fiche). On lit la couleur des BORDS de la photo (les côtés pour une photo en hauteur, le haut et le bas pour
   une photo en largeur) et, si ce bord est UNI, on la pose en fond de l'image elle-même : la bande prend exactement la
   couleur du fond de la photo. Rien n'est rogné ni retouché ; un bord non uni (écart-type > 16 : photo d'ambiance) est
   laissé tel quel.
   Chaque image a son propre fond (la 2ᵉ photo de survol garde le sien). Images du même domaine (/cdn/shop, CORS « * ») :
   la lecture des pixels est permise ; en cas de refus, rien ne change. */
(function () {
  var toile = document.createElement('canvas');
  var ctx = toile.getContext && toile.getContext('2d', { willReadFrequently: true });
  if (!ctx) { return; }
  function teinter(img) {
    if (!img.closest || !img.closest('.packshot') || img.getAttribute('data-moola-teinte')) { return; }
    var w = img.naturalWidth, h = img.naturalHeight;
    if (!w || !h || w < 16 || h < 16) { return; }   // pixel vide de la 2ᵉ photo au doigt, ou image pas encore décodée
    img.setAttribute('data-moola-teinte', '1');
    var r = w / h;
    if (Math.abs(r - 1) < 0.02) { return; }        // photo carrée : aucune bande
    var L = 48, cw = r >= 1 ? L : Math.max(2, Math.round(L * r)), ch = r >= 1 ? Math.max(2, Math.round(L / r)) : L;
    toile.width = cw; toile.height = ch;
    var d;
    try { ctx.drawImage(img, 0, 0, cw, ch); d = ctx.getImageData(0, 0, cw, ch).data; } catch (e) { return; }
    var px = [];
    var lire = function (x, y) { var i = (y * cw + x) * 4; px.push([d[i], d[i + 1], d[i + 2]]); };
    var k;
    if (r < 1) { for (k = 0; k < ch; k++) { lire(0, k); lire(cw - 1, k); } } else { for (k = 0; k < cw; k++) { lire(k, 0); lire(k, ch - 1); } }
    var m = [0, 0, 0];
    px.forEach(function (p) { m[0] += p[0]; m[1] += p[1]; m[2] += p[2]; });
    m = m.map(function (v) { return v / px.length; });
    var ecart = Math.sqrt(px.reduce(function (s, p) { return s + Math.pow(p[0] - m[0], 2) + Math.pow(p[1] - m[1], 2) + Math.pow(p[2] - m[2], 2); }, 0) / px.length / 3);
    if (ecart > 16) { return; }                     // bord non uni : photo d'ambiance, on ne touche à rien (16 : un fond
                                                    // légèrement dégradé reste accepté)
    img.style.backgroundColor = 'rgb(' + m.map(Math.round).join(',') + ')';
  }
  [].forEach.call(document.querySelectorAll('.packshot img'), function (i) { if (i.complete) { teinter(i); } });
  document.addEventListener('load', function (e) { if (e.target && e.target.tagName === 'IMG') { teinter(e.target); } }, true);
})();

/* Rails horizontaux (accueil, « Dans la même catégorie ») et bandeau de marques — revue du 04/10/2026.
   - Une carte qui reçoit le focus clavier est amenée ENTIÈRE dans le rail : Chrome ne fait défiler qu'un élément invisible,
     une carte visible à 23 % restait aux trois quarts hors écran (mesuré). block:'nearest' tient compte du
     scroll-padding-bottom de la page (barre d'achat, bandeau cookies).
   - Bouton pause du bandeau de marques : bouton bascule (aria-pressed, nom constant, comme le veut le motif ARIA). */
(function () {
  document.addEventListener('focusin', function (e) {
    var t = e.target;
    if (!t || !t.closest) { return; }
    // Carte de produit focalisée AU CLAVIER : amenée entière à l'écran. Chrome ne fait pas défiler un élément dont une
    // lisière dépasse — une carte de 350 px restait aux 9/10 sous le pli (mesuré le 04/10). Bornes = scroll-padding de la
    // page (en-tête en haut ; bandeau cookies et barre d'achat en bas), que block:'nearest' respecte.
    if (t.matches && t.matches('.card-link:focus-visible')) {
      var rc = t.getBoundingClientRect(), cs = getComputedStyle(document.documentElement);
      var haut = parseFloat(cs.scrollPaddingTop) || 0, bas = window.innerHeight - (parseFloat(cs.scrollPaddingBottom) || 0);
      if (rc.top < haut || rc.bottom > bas) { t.scrollIntoView({ block: 'nearest', behavior: 'instant' }); }
    }
    var rail = t.closest('.moola-rail, .similar-grid');
    if (!rail || rail.scrollWidth <= rail.clientWidth + 1) { return; }   // grille d'ordinateur : rien à faire défiler
    var li = t.closest('li');
    if (!li || li.parentElement !== rail) { return; }
    var r = li.getBoundingClientRect(), q = rail.getBoundingClientRect();
    if (r.left >= q.left - 1 && r.right <= q.right + 1) { return; }
    li.scrollIntoView({ block: 'nearest', inline: 'start', behavior: 'instant' });
  });
  var pause = document.querySelector('[data-marques-pause]');
  if (pause) {
    var bandeau = pause.closest('.moola-marques');
    pause.addEventListener('click', function () {
      var arret = pause.getAttribute('aria-pressed') !== 'true';
      pause.setAttribute('aria-pressed', String(arret));
      bandeau.classList.toggle('est-en-pause', arret);
    });
  }
})();
